import * as React from "react";
const SvgFiRrGingerbreadMan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-gingerbread-man_svg__a)">
      <path
        fill="#062147"
        d="M21.634 7.564A3.084 3.084 0 0 0 17.92 6.2l-1.21.419a4.984 4.984 0 1 0-9.416 0L6.078 6.2a3 3 0 1 0-2.06 5.635l1.635.566c1.7.57 1.581 2.752.728 4l-1.849 2.891A3.025 3.025 0 0 0 7.4 23.973a3 3 0 0 0 2.115-1.341l2.385-3.576a.17.17 0 0 1 .147-.079c.057-.02.115.027.15.082l2.22 3.463a3 3 0 1 0 5.112-3.141l-1.906-2.976c-.852-1.25-.976-3.435.728-4.005l1.632-.564a3.02 3.02 0 0 0 1.651-4.272M12 2a2.994 2.994 0 0 1 .314 5.968 4 4 0 0 1-.612 0A2.994 2.994 0 0 1 12 2m7.932 7.363a1 1 0 0 1-.607.582l-1.633.565c-2.923.946-3.355 4.678-1.756 6.974l1.906 2.976a1.002 1.002 0 0 1-1.746.983l-2.219-3.464a2.17 2.17 0 0 0-1.815-1 2.1 2.1 0 0 0-1.833.972l-2.386 3.59a1.006 1.006 0 0 1-1.522.2 1.085 1.085 0 0 1-.1-1.365l1.848-2.885c1.6-2.3 1.167-6.029-1.757-6.974L4.67 9.945a1.001 1.001 0 0 1 .756-1.854C6.816 8.529 10.582 10.077 12 10c1.418.079 5.19-1.483 6.572-1.91a1.015 1.015 0 0 1 1.36 1.273M13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-gingerbread-man_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGingerbreadMan;
